export default __webpack_public_path__ + "static/media/relevant-info.658f1d9e.svg";